<!--分层作业数据管理-->
<template>
    <div class="app-container">
        <div class="rqzj-manager-container">
            <!--系列-->
            <div class="l-container">
                <div class="l-top-container">
                    <div class="l-box">系列</div>
                    <div class="r-box cursor">
                        <div style="margin-top: 4px;">
                        </div>
                        <div style="text-indent: 2px;">
                            <el-button  type="primary" size="small" @click="handleTopCreate">
                                +系列
                            </el-button>
                        </div>
                    </div>
                </div>
                <el-scrollbar class="rqzj-l-tree-container">
                    <el-tree
                      class="custom-tree"
                      ref="categoryTree"
                      :data="categoryList"
                      node-key="categoryId"
                      :default-expanded-keys="expandedKeys"
                      :show-expand="true"
                      style="max-width: 240px;"
                      @node-expand="handleNodeExpand"
                      @node-click="handleNodeClick">
                        <template #default="{ data }">
                            <div class="custom-tree-node" :title="charConversion(data.categoryName)">
                                <div class="tree-l">
                                    <i>
                                        <svg t="1755142425021" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20345" width="16" height="16"><path d="M861.9 843.5c0 31.1-25.2 56.2-56.2 56.2H103.5l98.3-454.2c0-31 25-56.2 56.1-56.2h646.2c31 0 56.1 25.2 56.1 56.2l-98.3 398zM215.8 347.1h632v-55.2c0-31-25.2-56.2-56.2-56.2h-337v-50.9c0-31-25.2-56.2-56.2-56.2H117.6c-31 0-56.2 25.2-56.2 56.2v658.6l98.2-440.2c0-30.9 25.2-56.1 56.2-56.1z m0 0" p-id="20346" fill="#e99d42"></path></svg>
                                    </i>
                                    <span>{{charConversion(data.categoryName)}}</span>
                                </div>
                                <div class="tree-r">
                                    <el-icon class="cursor mr5"  title="新增系列" @click.stop="handleSonCreate(data)" >
                                        <Plus />
                                    </el-icon>
                                    <el-icon class="cursor mr5"  title="编辑系列" @click.stop="handleUpdate(data)">
                                        <Edit />
                                    </el-icon>
                                    <el-popconfirm confirm-button-text="是"
                                                   cancel-button-text="否"
                                                   icon-color="#626AEF" title="确定删除该系列"
                                                   @confirm="handleDeleteCategory(data.categoryId)">
                                        <template #reference>
                                            <el-icon class="cursor mr5" title="删除系列">
                                                <Delete />
                                            </el-icon>
                                        </template>
                                    </el-popconfirm>
                                    <el-icon class="cursor mr5" title="上传文件" @click.stop="handleFileUpload(data)">
                                        <Folder />
                                    </el-icon>
                                </div>
                            </div>
                        </template>
                    </el-tree>
                </el-scrollbar>
            </div>
            <!--文件列表-->
            <div class="r-container">
                <div class="form-box">
                    <el-form ref="queryForm"
                             :model="queryParams"
                             :inline="true"
                             label-width="90px">
                        <el-row >
                            <el-col :span="2">
                                <svg t="1775018007241" class="icon cursor" @click="resetSearch" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8064" width="30" height="30"><path d="M512 57.677643C261.084506 57.677643 57.677643 261.084506 57.677643 512s203.406863 454.322357 454.322357 454.322357 454.322357-203.406863 454.322357-454.322357S762.915494 57.677643 512 57.677643z" fill="#0d55a4" p-id="8065" data-spm-anchor-id="a313x.search_index.0.i11.35603a81rpIomP" class="selected"></path><path d="M581.060548 231.577511c-41.567834-41.568721-84.297206-66.239667-95.428104-55.108769-11.137997 11.137109 13.540936 53.86027 55.108769 95.428991a399.812548 399.812548 0 0 0 3.868839 3.816485c-18.446198-2.465941-38.703473-3.828908-59.958128-3.828908-77.080402 0-141.021837 17.917338-153.042745 41.397463-17.152444 22.420631-29.056222 71.617886-29.056222 128.705442 0 78.219757 22.352305 141.629671 49.931092 141.629671 27.578787 0 49.939965-63.409913 49.939965-141.629671 0-29.986163-3.285851-57.794773-8.891231-80.689248 25.579591 5.930149 57.067147 9.428076 91.118253 9.428076 22.752499 0 44.362094-1.561733 63.828742-4.367528a399.907494 399.907494 0 0 0-7.739452 7.534475c-41.568721 41.568721-66.240555 84.298094-55.109657 95.428991 11.137109 11.137109 53.86027-13.540049 95.428991-55.10877 34.770745-34.770745 57.718461-70.344541 57.776139-87.567972a16.620035 16.620035 0 0 0 0.897109-5.344499c0-2.19175-0.448111-4.351556-1.316825-6.468769-3.259231-18.402718-25.271681-51.17338-57.355535-83.25546z m40.5181 350.441373c0 29.983501 3.284076 57.788562 8.887681 80.682149-25.582253-5.927487-57.071584-9.425414-91.124464-9.425414-22.751612 0-44.360319 1.561733-63.825193 4.365754a405.916617 405.916617 0 0 0 7.747439-7.542461c41.568721-41.568721 66.240555-84.285671 55.102558-95.42278-11.130898-11.130898-53.853172 13.533837-95.42278 55.102558-34.768971 34.768971-57.715799 70.348977-57.779688 87.573296a16.628908 16.628908 0 0 0-0.894447 5.340063c0 2.184652 0.444562 4.337359 1.307064 6.447473 3.242371 18.400055 25.269019 51.187577 57.367958 83.287403 41.568721 41.567834 84.285671 66.240555 95.42278 55.102559 11.130898-11.130898-13.533837-53.853172-55.102558-95.42278a410.577858 410.577858 0 0 0-3.868839-3.81826c18.440873 2.466828 38.693712 3.828908 59.945706 3.828908 77.092825 0 141.048458-17.930648 153.056943-41.416985 17.148007-22.42773 29.051785-71.612562 29.051785-128.681483 0-78.228631-22.361179-141.638544-49.939966-141.638544-27.578787 0-49.931092 63.409913-49.931091 141.638544z" fill="#FFFFFF" p-id="8066"></path></svg>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="类型" label-width="40px">
                                    <el-select v-model="queryParams.categoryProfile" placeholder="请选择类型" @change="changeProfile">
                                        <el-option v-for="item in profileList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="15">
                                <el-form-item class="pull-right">
                                    <el-input v-model="queryParams.fileName" placeholder="请输入文件名称" class="input-with-select">
                                        <template #append>
                                            <el-button type="primary" @click="queryFileList(null)" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="bre9e mt5">
                    <div class="file-card-container" v-loading="loading">
                        <el-empty v-if="!loading && dataList.length == 0" description="暂无数据" />
                        <div v-for="(item, index) in dataList" :key="index" class="file-card">
                            <img class="file-card-cover cursor"
                                :src="item.fileCover || defaultCover"
                                @click="handleView(item)" />
                            <div class="file-card-edit">
                                <el-icon class="cursor" title="修改文件信息" @click.stop="handleEditFile(item)">
                                    <Edit />
                                </el-icon>
                            </div>
                            <div class="file-card-del">
                                <el-popconfirm confirm-button-text="是"
                                               cancel-button-text="否"
                                               icon-color="#626AEF" title="确定删除文件"
                                               @confirm="handleDeleteFile(item)">
                                    <template #reference>
                                        <el-icon class="cursor" title="删除文件" @click.stop>
                                            <Delete />
                                        </el-icon>
                                    </template>
                                </el-popconfirm>
                            </div>
                            <div class="file-card-name" :title="item.fileName">{{ item.fileName }}</div>
                        </div>
                    </div>
                </div>
                <div class="zdyfy">
                    <pagination class="zdyfy" :background="false"
                                :pageSizes="[10, 20, 30]"
                                :total="total"
                                v-model:page="queryParams.pageNum"
                                v-model:limit="queryParams.pageSize"
                                @pagination="queryFileList" />
                </div>
            </div>
        </div>
    </div>

    <el-dialog width="530px" :title="dialogTitle" v-model="isShowCategoryDialog">
        <div>
            <el-form label-width="60px">
                <el-form-item label="名称">
                    <el-input v-model="categoryForm.categoryName" placeholder="请输入系列名称"/>
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitCategory">
                    确定
                </el-button>
                <el-button @click="isShowCategoryDialog = !isShowCategoryDialog">
                    取消
                </el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog width="530px" :title="dialogTitle" v-model="isShowCategoryUpdateDialog">
        <div>
            <el-form>
                <el-input v-model="categoryForm.categoryName" placeholder="请输入系列名称"/>
            </el-form>
        </div>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitUpdateCategory">
                    确定
                </el-button>
                <el-button @click="isShowCategoryUpdateDialog = !isShowCategoryUpdateDialog">
                    取消
                </el-button>
            </div>
        </template>
    </el-dialog>

    <!--上传反思-->
    <el-dialog title="上传文件" v-model="isShowFileDialog" width="35%">
        <el-row>
            <el-col :span="24">
                <el-form-item label="文件封面">
                    <el-upload class="avatar-uploader"
                               :action="serviceUrl+'/businessservice/fileCategory/fileCover'"
                               :show-file-list="false"
                               :on-success="handleCoverSuccess"
                               :headers="{ token }"
                               :before-upload="beforeCoverUpload">
                        <img v-if="fileCover" :src="fileCover" class="avatar" style="position:absolute" />
                        <el-icon class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                            <Plus />
                        </el-icon>
                    </el-upload>
                    <div style="color: #a9abad;width:100%;">推荐使用尺寸比例4:3的图片</div>
                </el-form-item>
                <el-form-item label="上传文件" prop="title">
                    <el-upload class="upload-demo"
                               ref="upload"
                               multiple
                               v-model:file-list="fileList"
                               :action="serviceUrl+'/businessservice/fileCategory/fileUpload'"
                               :headers="{ token }"
                               :data="{ categoryId: this.categoryId, fileCover: this.fileCover}"
                               :on-remove="handleRemove"
                               :on-preview="handlePreview"
                               :on-success="handleSuccess"
                               :on-error="handleUploadError"
                               :before-upload="beforeUpload"
                               :auto-upload="false" >
                        <el-button type="primary">点击上传</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                支持上传文件大小不能超过2G。
                            </div>
                        </template>
                    </el-upload>
                </el-form-item>
            </el-col>
        </el-row>

        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" :loading="uploadLoading" @click="submitFileUpload">确定</el-button>
                <el-button @click="isShowFileDialog=!isShowFileDialog">取消</el-button>
            </div>
        </template>
    </el-dialog>

    <!--修改文件信息-->
    <el-dialog title="修改文件信息" v-model="isShowEditFileDialog" width="35%">
        <el-row>
            <el-col :span="24">
                <el-form-item label="文件封面">
                    <el-upload class="avatar-uploader"
                               :action="serviceUrl+'/businessservice/fileCategory/fileCover'"
                               :show-file-list="false"
                               :on-success="handleEditCoverSuccess"
                               :headers="{ token }"
                               :before-upload="beforeCoverUpload">
                        <img v-if="editFileForm.fileCover" :src="editFileForm.fileCover" class="avatar" style="position:absolute" />
                        <el-icon class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                            <Plus />
                        </el-icon>
                    </el-upload>
                    <div style="color: #a9abad;width:100%;">推荐使用尺寸比例4:3的图片</div>
                </el-form-item>
                <el-form-item label="文件名称">
                    <el-input v-model="editFileForm.fileName" placeholder="请输入文件名称"/>
                </el-form-item>
            </el-col>
        </el-row>

        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitEditFile">确定</el-button>
                <el-button @click="isShowEditFileDialog=!isShowEditFileDialog">取消</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import {serviceUrl} from "@/utils/global";
import {charConversion} from "@/utils/str"
import {createFileCategory,updateFileCategory,
    deleteFileCategory,treeFileCategory,
    pageCategoryFile,deleteFile,editFile} from "@/api/admin/fileCategory"
import {queryDict,downloadFile} from "@/api/adminservice/public"
import {timestampToTime} from "@/utils/date";

export default {
    name: "materialManager",
    components: {},
    data() {
        return {
            defaultCover:'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/mr_file.png',
            token: this.$storage.get("token"),
            charConversion,
            serviceUrl,
            loading: false,
            isShowCategoryDialog:false,
            isShowCategoryUpdateDialog:false,
            isShowFileDialog:false,
            isShowEditFileDialog:false,
            uploadLoading:false,
            treeList:{},
            treeData:{},
            categoryList:[],
            /*默认展开的系列节点*/
            expandedKeys:[],
            profileList:[],
            defaultProps: {
                children: 'children',
                label: 'categoryName',
            },
            dialogTitle:'',
            fileCover:'',
            //修改文件信息
            editFileForm:{
                fileId: '',
                fileName: '',
                fileCover: '',
            },
            categoryForm:{
                categoryId: '',
                parentId: '',
                categoryName: '',
                categoryProfile: '',
            },
            queryCategoryForm:{
                categoryProfile: '',
            },
            //文件上传】
            fileList:[],
            delFileList:[],
            categoryId:'',
            fileName:'',
            //查询文件分页
            queryParams:{
                pageNum: 1,
                pageSize: 10,
                categoryProfile: '',
                fileName: '',
                categoryId: '',
            },
            total: 0,
            dataList: [],

        }
    },
    computed: {},
    watch: {},
    created() {
        this.getQueryDict();
    },
    mounted(){},
    methods: {
        timestampToTime,
        // 查询类型字典
        getQueryDict() {
            queryDict({ code: 'material_classify' }).then(res => {
                if (res.data.code === 1) {
                    this.profileList = res.data.data || [];
                    if (this.profileList.length > 0) {
                        // 类型默认第一个，从详情页返回时恢复类型
                        const routeProfile = this.$route.query.profile;
                        const currentProfile = this.profileList.find(e => String(e.dictKey) === String(routeProfile)) || this.profileList[0];
                        this.queryParams.categoryProfile = currentProfile.dictKey;
                        this.queryCategoryForm.categoryProfile = currentProfile.dictKey;
                    }
                    // 从详情页返回时恢复搜索条件
                    if (this.$route.query.fileName) {
                        this.queryParams.fileName = this.$route.query.fileName
                    }
                    if (this.$route.query.categoryId) {
                        this.queryParams.categoryId = this.$route.query.categoryId
                    }
                    if (this.$route.query.pageNum) {
                        this.queryParams.pageNum = Number(this.$route.query.pageNum)
                    }
                    if (this.$route.query.pageSize) {
                        this.queryParams.pageSize = Number(this.$route.query.pageSize)
                    }
                    this.queryTreeCategory();
                    this.queryFileList(null);
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 类型切换
        changeProfile() {
            this.queryCategoryForm.categoryProfile = this.queryParams.categoryProfile;
            this.queryParams.categoryId = '';
            this.queryTreeCategory();
            this.queryFileList(null);
        },
        resetSearch(){
            this.queryParams.fileName = '';
            this.queryParams.categoryId = '';
            this.queryFileList(null);
        },
        handleNodeClick(e, i){
            this.queryParams.categoryId=e.categoryId;
            this.queryFileList();
        },
        // 节点展开时折叠其他节点，只能展开一个
        handleNodeExpand(data){
            const nodesMap = this.$refs.categoryTree.store.nodesMap;
            Object.keys(nodesMap).forEach(key => {
                const node = nodesMap[key];
                if (node.expanded && node.data.categoryId !== data.categoryId) {
                    node.collapse();
                }
            })
        },
        queryFileList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageCategoryFile(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        handleView(file){
            // fileType为文件后缀名，统一转小写并去掉可能带有的前缀点，不区分大小写
            const fileType = (file.fileType || '').toLowerCase().replace(/^\./, '');
            // 图片、word、pdf、ppt之外的文件暂不支持预览，提示用户下载使用
            if (!/^(png|jpe?g|gif|bmp|webp|svg|doc|docx|pdf|ppt|pptx)$/.test(fileType)) {
                this.handleUnsupport(file);
                return;
            }
            this.$router.push({
                path: "/materialView",
                query: {
                    fileId: file.fileId,
                    profile: this.queryParams.categoryProfile,
                    fileName: this.queryParams.fileName,
                    categoryId: this.queryParams.categoryId,
                    pageNum: this.queryParams.pageNum,
                    pageSize: this.queryParams.pageSize,
                }
            });

        },
        // 暂不支持预览的文件，提示下载使用
        handleUnsupport(file){
            this.$confirm("暂不支持预览，可下载使用", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                downloadFile(file.fileUrl, file.fileName);
            }).catch(() => {});
        },
        handleDeleteFile(file){
            deleteFile({fileId:file.fileId}).then((res)=>{
                if (res.data.code === 1) {
                    this.queryFileList(null);
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 修改文件信息
        handleEditFile(file){
            this.editFileForm.fileId = file.fileId;
            this.editFileForm.fileName = file.fileName;
            this.editFileForm.fileCover = file.fileCover || this.defaultCover;
            this.isShowEditFileDialog = true;
        },
        handleEditCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.editFileForm.fileCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        submitEditFile(){
            if (!this.editFileForm.fileName){
                this.$message.info("请输入文件名称")
                return;
            }
            editFile(this.editFileForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryFileList(null);
                    this.isShowEditFileDialog = false;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        //新增父级节点
        handleTopCreate(){
            this.dialogTitle = '新建系列'
            this.categoryForm.parentId = '0';
            // 类型默认取当前筛选类型，弹窗中不展示
            this.categoryForm.categoryProfile = this.queryParams.categoryProfile;
            this.isShowCategoryDialog = true;
        },
        // 新增子节点
        handleSonCreate(data){
            this.dialogTitle = '新建系列'
            this.categoryForm.parentId = data.categoryId;
            // 子系列：类型跟随父级，弹窗中不展示
            this.categoryForm.categoryProfile = data.categoryProfile || this.queryParams.categoryProfile;
            this.isShowCategoryDialog = true;
        },
        // 提交修改
        handleUpdate(data){
            this.dialogTitle = '修改系列名称'
            this.categoryForm.categoryId = data.categoryId;
            this.categoryForm.categoryName = data.categoryName;
            this.categoryForm.categoryProfile = data.categoryProfile || this.queryParams.categoryProfile;
            this.isShowCategoryUpdateDialog = true;
        },
        //提交新增
        submitCategory(){
            if (!this.categoryForm.categoryProfile){
                this.$message.info("请选择类型")
                return;
            }
            if (!this.categoryForm.categoryName){
                this.$message.info("请输入名称")
                return;
            }
            createFileCategory(this.categoryForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.resetForm();
                    this.queryTreeCategory();
                    this.isShowCategoryDialog = false;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        //提交修改
        submitUpdateCategory(){
            if (!this.categoryForm.categoryName){
                this.$message.info("请输入名称")
                return;
            }
            updateFileCategory(this.categoryForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.resetForm();
                    this.queryTreeCategory();
                    this.isShowCategoryUpdateDialog = false;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        //提交删除
        handleDeleteCategory(cId){
            deleteFileCategory({ categoryId: cId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryTreeCategory();
                    this.queryFileList(null)
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 查询树结构
        queryTreeCategory(){
            treeFileCategory(this.queryCategoryForm).then(res => {
                if (res.data.code === 1) {
                    this.categoryList = res.data.data;
                    // 默认展开第一个系列
                    this.expandedKeys = this.categoryList.length > 0 ? [this.categoryList[0].categoryId] : [];
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 重置表单
        resetForm(){
            this.categoryForm.categoryName = '';
        },
        // 上传文件
        handleFileUpload(data){
            this.fileList = []
            this.fileCover = this.defaultCover;
            this.uploadLoading = false;
            this.categoryId = data.categoryId;
            this.isShowFileDialog = true;
        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.fileCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeCoverUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleRemove(file, uploadFiles) {

        },
        handlePreview(file) {

        },
        handleSuccess(response, uploadFile) {
            this.uploadLoading = false;
            if (uploadFile.response.code === 1) {
                this.queryFileList(null)
                this.isShowFileDialog = false;
            } else {
                this.$message.error("上传失败")
            }
        },
        handleUploadError() {
            this.uploadLoading = false;
            this.$message.error("上传失败")
        },
        beforeUpload(rawFile) { 
            // 放开类型限制，可上传所有类型文件，仅限制大小
            if (rawFile.size / 1024 / 1024 > 2048) {
                this.$message.error('文件大小超过限制')
                return false
            }
            return true
        },
        submitFileUpload(){
            if (this.fileList.length == 0) {
                this.$message.info("请选择要上传的文件")
                return;
            }
            this.uploadLoading = true;
            this.$refs.upload.submit();
        }
    }
}
</script>
<style>
.rqzj-manager-container{
    width: 100%;
    height: calc(100vh - 85px);
    overflow: hidden!important;
    box-sizing: border-box;
    display: flex;
}
.l-container{
    width: 260px;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
}
.l-top-container{
    width: 100%;
    height: 50px;
    padding: 10px 0 10px 0;
    line-height: 28px;
    box-sizing: border-box;
    border-bottom: 1.5px solid #f1f1f1;
    display: flex;
}
.l-box{
    width: 50%;
    height: 100%;
    line-height: 28px;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: left;
    padding-left: 10px;
    color: #242424;
}
.r-box{
    width: 50%;
    height: 100%;
    font-size: 15px;
    font-family: sans-serif;
    text-align: right;
    padding-right: 10px;
    color: #676767;
    display: flex;
    justify-content: flex-end;
}
.rqzj-l-tree-container{
    width: 100%;
    height: calc(100% - 60px)!important;
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
/*.custom-tree .el-tree-node__expand-icon {
    display: none;
}*/

.custom-tree-node{
    width: calc(100% - 24px);
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.tree-l{
    width: calc(100% - 90px);
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略号来表示溢出内容 */
}
.tree-r{
    width: 70px;
    display: flex;
}
.r-container{
    width: calc(100% - 270px);
    height: 100%;
    margin-left: 10px;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}.avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}
.file-card-container{
    height: calc(100vh - 215px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 10px;
    box-sizing: border-box;
}
/*无数据时暂无数据提示居中*/
.file-card-container .el-empty{
    margin: auto;
}
.file-card{
    width: 200px;
    margin: 0 15px 15px 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
}
.file-card-cover{
    width: 100%;
    height: 150px; /* 高度固定，宽度拉伸填满 */
    object-fit: fill;
    display: block;
}
.file-card-edit{
    display: none;
    position: absolute;
    left: 5px;
    top: 5px;
    font-size: 18px;
    color: #0d55a4;
    background-color: #e4e7ed;
    z-index: 99;
}
.file-card:hover .file-card-edit{
    display: block;
}
.file-card-del{
    display: none;
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 18px;
    color: red;
    background-color: #e4e7ed;
    z-index: 99;
}
.file-card:hover .file-card-del{
    display: block;
}
.file-card-name{
    padding: 8px 10px;
    font-size: 14px;
    color: #242424;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>